
/*
 *   File : pagination.js
 *   Author URI : https://evoqins.com
 *   Description : Index page for blog listing
 *   Integrations : ReactPaginate
 *   Version : v1.0
 */

import { memo } from 'react';
import ReactPaginate from 'react-paginate';
import { Icon } from '../Icon';

// styles
import color from '../../Style/color.scss';

const Pagination = (props) => {

    // handle page click 
    const _handlePageClick = (event) => {
        let new_start_limit = event.selected * props.itemsPerPage;
        let new_end_limit = new_start_limit + props.itemsPerPage;
        props.onChange(new_start_limit, new_end_limit);
    }

    const _goToPage = (pageIndex) => {
        let new_start_limit = pageIndex * props.itemsPerPage;
        let new_end_limit = new_start_limit + props.itemsPerPage;
        props.onChange(new_start_limit, new_end_limit);
    };

    const startItem = (props.currentPage - 1) * props.itemsPerPage + 1;
    const endItem = Math.min(props.currentPage * props.itemsPerPage, props.totalItems);

    return (

        <div className='d-flex align-items-center justify-content-between'>

            <div>
                <p className='mb-0 e-text-charleston-green e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                    Page {props.currentPage} of {props.totalPage} ({props.totalItems} total entries)
                    {/* Showing {startItem} - {endItem} of {props.totalItems} entries */}
                </p>
            </div>
            <div className='d-flex align-items-center'>
                <div
                    className={`${props.forcePage === 0 ? "opacity-75 pe-none" : ""} e-page-button p-2 cursor-pointer e-bg-anti-flash-white border-radius-8`}
                    onClick={() => _goToPage(0)}
                    disabled={props.forcePage === 0}
                >
                    <Icon icon='double-arrow' size={20} className='d-flex e-rotate-180' />
                </div>
                <ReactPaginate
                    breakLabel="..."
                    pageRangeDisplayed={props.pageRangeDisplayed}
                    pageCount={props.totalPage}
                    renderOnZeroPageCount={null}
                    pageClassName="e-page-item"
                    previousClassName="e-prev-button"
                    nextClassName="e-next-button"
                    forcePage={props.forcePage}
                    containerClassName={`${props.className} e-pagination`}
                    activeClassName="e-active"
                    marginPagesDisplayed={props.marginPagesDisplayed}
                    nextLabel={<Icon icon='dropdown'
                        size='1.25rem'
                        color={color.space_cadet}
                        className='d-flex e-rotate-270' />}
                    previousLabel={<Icon icon='dropdown'
                        size='1.25rem'
                        color={color.space_cadet}
                        className='d-flex e-rotate-90' />}
                    onPageChange={_handlePageClick}
                />

                <div
                    className={`${props.forcePage === props.totalPage - 1 ? "opacity-75 pe-none" : ""} e-page-button p-2 cursor-pointer  e-bg-anti-flash-white border-radius-8`}
                    onClick={() => _goToPage(props.totalPage - 1)}
                    disabled={props.forcePage === props.totalPage - 1}
                >
                    <Icon icon='double-arrow' size={20} className='d-flex' />
                </div>
            </div>
        </div>
    )
};

export default memo(Pagination);